<template>
    <a-card>
        <a-form>
            <a-input-group compact class="">
            <a-select v-model:value="searchType" style="width: 100px">
                <a-select-option value="name">分组名称</a-select-option>
                <a-select-option value="number">分组编号</a-select-option>
            </a-select>
            <a-input-search style="width: 50%" placeholder="请输入搜索内容" enter-button="搜索" @search="onSearch"/>
        </a-input-group>
        </a-form>

        <div class="table-toolbar mt-20">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
        </div>
        <a-table
            :columns="columns"
            :pagination="false"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange"
            :expandedRowKeys="expandedRowKeys"
            @expandedRowsChange="onExpandedRowsChange"
        >
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #name="{record}">
                <span v-if="record.name.indexOf(searchVal) > -1&&searchType==='name'">
                    {{ record.name.substr(0, record.name.indexOf(searchVal)) }}
                    <span class="tc-red">{{ searchVal }}</span>
                    {{ record.name.substr(record.name.indexOf(searchVal) + searchVal.length) }}
                </span>
                <span v-else>{{ record.name }}</span>
            </template>
            <template #number="{record}">
                <span v-if="record.number.indexOf(searchVal) > -1&&searchType==='number'">
                    {{ record.number.substr(0, record.number.indexOf(searchVal)) }}
                    <span class="tc-red">{{ searchVal }}</span>
                    {{ record.number.substr(record.number.indexOf(searchVal) + searchVal.length) }}
                </span>
                <span v-else>{{ record.number }}</span>
            </template>
            <template #enabled="{record}">
                <switch-btn
                    :value="record.enabled"
                    key-field="enabled"
                    :switch-url="switchUrl"
                    :params="{id:record.id}"
                    @ok="loadData"/>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record.id)">编辑</a>
                    <a-popconfirm title="确认要删除吗?" @confirm="onDelete(record.id)">
                        <a class="delete">删除</a>
                    </a-popconfirm>
                    <a @click="onDetail(record.number)">字典项</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditGroup ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited" :plist="dataSource"/>
    <DictItemList ref="dictItemList"/>
</template>
<script>
import {tableListMixin} from "@/mixins";
import AddOrEditGroup from "./components/AddOrEditGroup";
import {sys_dict_group_controller} from "@/api/adminService";
import DictItemList from "@/views/sys/dict/components/DictItemList";

const convertTreeData = (datas = [], rootValue = "0") => {
    let list = datas.filter((v) => {
        return v['superId'] === rootValue;
    });
    list.forEach((v) => {
        v.children = convertTreeData(datas, v.key);
    })
    return list;
}
const getParentKey = (val, tree, keyName) => {
    let parentObj = {};
    tree.forEach(v => {
        parentObj[v.groupId] = v.superId;
    })
    const addParentKey = (key) => {
        let list = [];
        if (parentObj[key]) {
            list.push(parentObj[key]);
            list.push(...addParentKey(parentObj[key]))
        }
        return list
    }
    if (val) {
        let parentKeys = [];
        tree.forEach((v) => {
            if ((v[keyName]).indexOf(val) > -1) {
                parentKeys.push(v.groupId)
                parentKeys.push(...addParentKey(v.groupId))
            }
        })

        return Array.from(new Set(parentKeys));
    } else {
        return []
    }
}

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    // {title: "superId", dataIndex: "superId", key: "superId"},
    {title: "分组名称", dataIndex: "name", key: "name", slots: {customRender: "name"}},
    {title: "分组编号", dataIndex: "number", key: "number", slots: {customRender: "number"}},
    {title: "描述", dataIndex: "remark", key: "remark"},
    {title: "排序", dataIndex: "sort", key: "sort"},
    {title: "是否启用", dataIndex: "enabled", key: "enabled", slots: {customRender: "enabled"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        DictItemList,
        AddOrEditGroup,
    },
    data() {
        return {
            columns,
            pagination: {
                current: 1,
                pageSize: 10000,
                total: 0,
            },
            queryParam: {},
            listUrl: sys_dict_group_controller.getPageListData,
            listKeyField: "id",
            deleteUrl: sys_dict_group_controller.remove,
            dataSourceTree: [],
            switchUrl: sys_dict_group_controller.saveOrUpdate,

            searchType: 'name',
            searchVal: '',
            expandedRowKeys: [],
        }
    },
    watch: {
        dataSource: {
            handler(newVal) {
                this.dataSourceTree = convertTreeData(newVal, "0");
            },
            immediate: true,
        },
    },
    methods: {
        onSearch(value) {
            this.searchVal = value;
            this.expandedRowKeys = getParentKey(value, this.dataSource, this.searchType);
        },
        onExpandedRowsChange(expandedRowKeys) {
            this.expandedRowKeys = expandedRowKeys;
        },
        onAdd() {
            this.onShowModal("modal");
        },
        onEdit(id) {
            this.getAction({
                url: sys_dict_group_controller.getDetail,
                params: {id: id},
                returnMsg: true
            }).then(res => {
                this.onShowModal("modal", res.data || {});
            })
        },
        onDetail(key) {
            const dictItemList = this.$refs.dictItemList;
            dictItemList.queryParamFixed.groupNumber = key;
            dictItemList.visible = true;
            dictItemList.loadData(1);
        }
    }
}
</script>
<style scoped lang="less">
.ant-form{
  padding: 20px;
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
